import React from "react";

const Flag = ({ country }) => (
    <span className="flag-container">
      <img 
        src={`/flags/${country.isoCode.toLowerCase()}.svg`}
        alt={country.name}
        className="flag-icon"
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'inline';
        }}
      />
      <span className="emoji-fallback" style={{ display: 'none' }}>
        {country.emoji}
      </span>
    </span>
  );

export default Flag;